// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import router from './router/index.js';//直播分享预览页面
// import router from './router/index-signSystem.js';//搜了宝签到系统
// import router from './router/index-annualMeeting.js';//年会中奖查询
// import router from './router/index-lhfn-navApp.js';//链合赋能 公众号跳转App
// import router from './router/index-customerService.js';//链合赋能、国甄、搜了宝 客服聊天
// import router from './router/index-equity'; //股权查询
import router from './router/index-download'; //农产品搜缘下载
import 'normalize.css';
import store from './vuex/store.js';
// 公共样式
import './common/common.css';

/* 引入axios */
import axios from './common/axios.js'
import qs from 'qs';
/* 富文本 */
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// vant
import Vant from 'vant';
import 'vant/lib/index.css';
// 公用
import {util} from './common/js/util.js'
// import VConsole from 'vconsole';
Vue.use(VueQuillEditor, {
  placeholder: '请输入内容',
});

// const vConsole = new VConsole()
Vue.use(ElementUI)

Vue.use(Vant);

// import {httpRequest,util} from './common/js/util.js';
// import baseURL from './common/api_url/baseURL.js';
// console.log(util.dateFormat(new Date(),'yyyy-MM-dd hh:mm:ss'))

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
// Vue.prototype.$api = api;
Vue.prototype.$util = util
// Vue.prototype.$httpRequest = httpRequest
// Vue.prototype.$baseUrl = baseURL

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js